/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import FeelingEvasSectionContent from "parog-web/components/feeling-evas/sliders/component";
import type { EmberChangeset } from "ember-changeset";
import { runTask } from "ember-lifeline";
import type { WrFormComponentSignature } from "ember-wiser/components/wr/form";

interface Signature {
  Args: {
    key: string;
    form: WrFormComponentSignature<
      EmberChangeset,
      unknown
    >["Blocks"]["default"][0];
  };
}

export default class MiciBaseEditionFormSliderComponent extends FeelingEvasSectionContent<Signature> {
  constructor(owner: unknown, args: Signature["Args"]) {
    super(owner, args);
    runTask(this, () => {
      if (!this.args.form.data?.get(this.args.key)) {
        this.args.form.data?.set(this.args.key, "0");
      }
    });
  }

  @action
  onChange(value: number) {
    this.args.form.data?.set(this.args.key, value.toString());
  }

  get value(): string {
    return this.args.form.data?.get(this.args.key);
  }
}
